import { useTranslations } from 'next-intl';
import ContactDealerMobileDrawer from 'components/contact-dealer-mobile-drawer';
import { LocationAddress } from 'services/location/types';
import cx from 'classnames';
import styles from './availability-message.module.scss';

export interface AvailabilityMessageProps {
  availabilityMessage: string;
  showContactDealerPopUp: boolean;
  isCustomerSupportEnabled: boolean;
  address: LocationAddress;
  locale: string;
}

const AvailabilityMessage = ({
  availabilityMessage,
  showContactDealerPopUp,
  isCustomerSupportEnabled,
  address,
  locale
}: AvailabilityMessageProps) => {
  const t = useTranslations();

  return showContactDealerPopUp ? (
    <ContactDealerMobileDrawer
      locale={locale}
      dealerAddress={address}
      isCustomerSupportEnabled={isCustomerSupportEnabled}
      variant="inline"
      size="md"
      msg={t('FOOTER_CONTACT_US')}
      className="d-inline-flex"
      fullWidth={false}
    />
  ) : (
    <p
      data-testid="availability-message"
      className={cx(
        'cat-u-theme-typography-label-sm mb-0',
        styles['availability-message__text']
      )}
    >
      {availabilityMessage}
    </p>
  );
};

export default AvailabilityMessage;
